import React from 'react'
import { PriceMethodProps } from './type'
import Image from '@/components/base/image/Image'

const PriceMethod: React.FunctionComponent<PriceMethodProps> = ({
  title,
  methods,
}) => {
  return (
    <div className="price-method">
      <div className="price-method-title">{title}</div>
      <div className="methods">
        <ul>
          {methods?.map((item, index) => (
            <li key={index}>
              <Image {...item.image} alt={item.title} />
              <div className="title">
                <b>{item.title}</b>
                <div dangerouslySetInnerHTML={{ __html: item.desc }} />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default PriceMethod
